module.exports = "https://99designs-start-assets.imgix.net/js/0184c7b01f90772fdcb1843e7b07e1ac.png";